import dateFormat from "dateformat"
import {DATE_FORMAT} from "../constants/Constants"

export function dateFormatDDMMYYYY(value) {
    let dateStr = typeof value.getMonth === "function" ?
        value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate() :
        value;
    return dateFormat(dateStr.toString(), "dd-mm-yyyy");
}

export function strToDate(value) {
    if (value === "") {
        return "";
    } else {
        try {
            let dateObj = '';
            if (typeof value.getMonth === "function") {
                dateObj = value;
            } else {
                let replacedDate = (value + '').indexOf('-') === -1 ?
                    dateFormat(value, "yyyy-mm-dd") :
                    value ?
                        value.toString().replace(/-/g, '/') : "";
                replacedDate = replacedDate.toString().indexOf(':') === -1 ?
                    replacedDate : replacedDate.substr(0, 10);
                dateObj = new Date(replacedDate);
            }
            return dateObj;
        } catch (e) {
            return "";
        }
    }
}

export function dateDDMMYY(value) {
    if (value === "") {
        return "";
    } else {
        try {
            let dateObj = '';
            if (typeof value.getMonth === "function") {
                dateObj = value;
            } else {
                let replacedDate = (value + '').indexOf('-') === -1 ?
                    dateFormat(value, "yyyy-mm-dd") :
                    value ?
                        value.toString().replace(/-/g, '/') : "";

                replacedDate = replacedDate.toString().indexOf(':') === -1 ?
                    replacedDate : replacedDate.substr(0, 10);

                replacedDate = replacedDate  + " 06:00";

                dateObj = new Date(replacedDate);
            }
            let dateStr = dateObj.getFullYear() + "/" + (dateObj.getMonth() + 1) + "/" + dateObj.getDate();
            return dateFormat(dateStr.toString(), DATE_FORMAT);
        } catch (e) {
            return "";
        }
    }
}

export function dateDDMMYYDataTableTemplate(rowData, column) {
    return dateDDMMYY(rowData[column['field']]);
}

export function dateFormatterReportTable(rowData, column) {
    return rowData[column['field']].replace(/-/g, '/');
}

export function getTimeFromStringDate(date){
    let datePr = new Date(date);
    return datePr.toLocaleTimeString();
}

export function formatYYYMMDD(value) {
    let dateStr = typeof value.getMonth === "function" ?
        value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate() :
        value;
    return dateFormat(dateStr.toString(), "yyyy-mm-dd");
}
